<div class="topnav">
    <span class="navbar-icon ml-3" (click)="toggleNav()" data-toggle="tooltip-topNav"
        title="Press Esc Key to toggle">&#9776;
    </span>
</div>
<div id="sidenav" class="sidenav-collapse">
    <div class="container-fluid sidenav-buttons" id="sidenav-buttons">
        <div class="create mt-4">
            <button type="button" class="btn create-button" data-toggle="modal" data-target="#taskModal">
                Add Task +
            </button>
        </div>
        <div class="create mt-5" *ngIf="!toggleUndoButton">
            <button type="button" class="btn undo-button" (click)="performUndoOperation()">
                Undo Changes
            </button>
        </div>
        <div class="logout mt-5 mb-3">
            <button type="button" class="btn btn-warning projects-button" (click)="navigateToCollabHomeComponent()">
                View Projects
            </button>
        </div>
        <div class="disconnect mt-5">
            <button type="button" class="btn btn-info disconnect-button mr-1" (click)="navigateToMainHomeComponent()">
                Disconnect
            </button>
        </div>
        <div class="logout mt-5 mb-3">
            <button type="button" class="btn btn-danger logout-button" (click)="logoutUser()">
                Logout
            </button>
        </div>
    </div>
</div>
<!-- <div *ngIf="loaderService.loading | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div> -->
<div class="slider-bar" *ngIf="loaderService.loading | async">
    <div class="line-bar"></div>
    <div class="subline-bar inc"></div>
    <div class="subline-bar dec"></div>
</div>
<div class="modal fade" id="taskModal" tabindex="-1" role="dialog" aria-labelledby="taskModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">Enter the name of Task</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-tooltip="">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="itemModalForm" (ngSubmit)="itemModalFormSubmit()">
                <div class="modal-body">
                    <div class="form-group">
                        <input type="text" class="form-control" [ngClass]="{
                                'has-danger': ((itemModalForm.get('itemName').invalid && itemModalForm.get('itemName').dirty)||(itemModalForm.get('itemName').touched && itemModalForm.get('itemName').pristine)),
                                'has-success': itemModalForm.get('itemName').valid && itemModalForm.get('itemName').dirty
                              }" formControlName="itemName" data-toggle="tooltip"
                            title="Maximum 25 alphanumeric characters">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="submit" [disabled]="!itemModalForm.get('itemName').valid"
                        class="btn btn-primary">Apply
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal fade" id="subTaskModal" tabindex="-1" role="dialog" aria-labelledby="subtaskModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalCenterTitle">Enter the name of Sub-Task</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-tooltip="">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="subItemModalForm" (ngSubmit)="subItemModalFormSubmit()">
                <div class="modal-body">
                    <div class="form-group">
                        <input type="text" class="form-control" [ngClass]="{
                                'has-danger': ((subItemModalForm.get('subItemName').invalid && subItemModalForm.get('subItemName').dirty)||(subItemModalForm.get('subItemName').touched && subItemModalForm.get('subItemName').pristine)),
                                'has-success': subItemModalForm.get('subItemName').valid && subItemModalForm.get('subItemName').dirty
                              }" formControlName="subItemName" data-toggle="tooltip"
                            title="Maximum 20 alphanumeric characters">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="submit" [disabled]="!subItemModalForm.get('subItemName').valid"
                        class="btn btn-primary">Apply
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal fade" id="editItemModal" tabindex="-1" role="dialog" aria-labelledby="editItemModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalCenterTitle">Enter the new Task name</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-tooltip="">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="editItemModalForm" (ngSubmit)="editItemModalFormSubmit()">
                <div class="modal-body">
                    <div class="form-group">
                        <input type="text" class="form-control" [ngClass]="{
                                'has-danger': ((editItemModalForm.get('editItemName').invalid && editItemModalForm.get('editItemName').dirty)||(editItemModalForm.get('editItemName').touched && editItemModalForm.get('editItemName').pristine)),
                                'has-success': editItemModalForm.get('editItemName').valid && editItemModalForm.get('editItemName').dirty
                              }" formControlName="editItemName" data-toggle="tooltip"
                            title="Maximum 25 alphanumeric characters">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="submit" [disabled]="!editItemModalForm.get('editItemName').valid"
                        class="btn btn-primary">Apply
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div id="main-content" class="main-content">
    <div class="sub-content" *ngIf="spinner">
        <div class="row ">
            <div class="container project-heading text-center">
                <div class="spinner-grow text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>
    <div class="sub-content" *ngIf="!toggleMainMessage && !spinner">
        <div class="row ">
            <div class="container task-heading text-center">
                <h4>There are no tasks!</h4>
            </div>
        </div>
    </div>
    <div class="sub-content" [ngClass]="{'all-success':successValue}" *ngIf="toggleMainMessage && !spinner">
        <div class="row ">
            <div class="container task-heading text-center">
                <h3>Tasks in
                    {{projectName}} Project</h3>
            </div>
        </div>
        <div class="row">
            <div *ngFor="let item of itemNamesList" class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                <div class="card text-center text-white bg-dark mb-3 " [ngClass]="{
                    'has-danger': !statusMapping[item],
                    'has-success': statusMapping[item]
                  }" style="border-radius:10px;">
                    <div class="card-body">
                        <h5 class="card-title">{{item}}</h5>
                        <div class="sub-tasks-node text-justify">
                            <ul *ngFor="let subTask of subTaskMapping[item]; let i = index">
                                <li>{{subTask}}</li>
                            </ul>
                        </div>
                        <button type="button" class="btn btn-warning btn-sm" data-toggle="modal"
                            data-target="#subTaskModal" [disabled]="statusMapping[item]" (click)="getItemName(item)">Add
                            sub-task(s)
                        </button>
                    </div>
                    <div class="card-footer text-muted footer">
                        <button type="button" class="btn btn-success" [disabled]="statusMapping[item]"
                            (click)="markedAsDone(item)">Done</button>
                        <button type="button" class="btn btn-info" data-toggle="modal" data-target="#editItemModal"
                            [disabled]="statusMapping[item]" (click)="getItemName(item)">Edit</button>
                        <button type=" button" class="btn btn-danger" (click)="deleteTask(item)">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>